import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { formatDataBeforeView } from '../../../helpers/GeneralHelper';

export const ContactView = ({module, showModal, setShowModal, data}) => {

  const inputFields = {
    contact_name: 'POC Name',
    client_name: 'Client',
    contact_mobile: 'Contact Number',
    contact_email: 'Email',
    contact_designation: 'Designation',
    contact_skills: 'LOB/Skills/Departments Managed',
    contact_last_contacted: 'Last Contacted',
    contact_meeting_mom: 'MoM of the meeting',
    contact_update_time: 'Updated At',
    contact_create_time: 'Created At',
  }
  const formatOptions = [
    {
      'type': 'date',
      'column': 'contact_last_contacted',
    },
    {
      'type': 'datetime',
      'column': 'contact_update_time',
    },
    {
      'type': 'datetime',
      'column': 'contact_create_time',
    },
  ];

  const [fields, setFields] = useState(inputFields);
  useEffect(() => {
    if (data) {
      setFields(formatDataBeforeView(data, formatOptions));
    }
  }, [data]);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
      <Modal.Header closeButton>
          <Modal.Title>View {module.singularTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-bordered table-hover table-sm">
          <tbody>
            {Object.keys(inputFields).map((item) => 
              <tr key={item}>
                <td>{inputFields[item]}</td>
                <th>{fields[item]}</th>
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};
